module.exports = __webpack_public_path__ + "img/D2F4_new.71cc586b.jpg";